import { FaLinkedin, FaInstagram, FaFacebookSquare } from "react-icons/fa";
import { FiPhone, FiMail } from "react-icons/fi";
import Form from "../components/contactForm";
import { HashLink as Link } from "react-router-hash-link";

const ContactPage = () => {
  return (
    <div className="page-container contact-page-container">
      <section className="get-in-touch">
        <div className="section-header-line">
          <h2>get in touch</h2> <hr />
        </div>
        <div className="content-container">
          <div className="contact-form">
            <Form />
          </div>
          <div className="contact-details">
            <div className="contact-us">
              <h3>contact us</h3>
              <Link to="mailto:info@awayhomezone.com">
                <div className="contact-detail">
                  <FiMail className="contact-icon" />
                  <span>info@awayhomezone.com</span>
                </div>
              </Link>
              <div className="contact-detail">
                <FiPhone className="contact-icon" />
                <div className="detail-span-holder">
                  <Link to="tel:+442088586268">
                    <span>+44(0)20 8858 6268 </span>
                  </Link>
                  <Link to="tel:+447415977597">
                    <span>+44(0)7415 977 597</span>
                  </Link>
                </div>
              </div>
            </div>
            <div className="follow-us">
              <h3>follow us</h3>

              <Link to="https://www.linkedin.com/company/106850996/admin/dashboard/">
                <div className="contact-detail">
                  <FaLinkedin className="contact-icon" />
                  <span>@awayhomezone</span>
                </div>
              </Link>
              <Link to="https://www.instagram.com/awayhomezone/?igsh=MTJ6bTh5bWNkZmplOA%3D%3D#">
                <div className="contact-detail">
                  <FaInstagram className="contact-icon" />
                  <span>@awayhomezone</span>
                </div>
              </Link>
              <Link to="https://www.facebook.com/people/Away-Homezone/pfbid0Dk2FY4ctP3nYiFjMp8KNMCjGipJ1YbTKdqmZ1VydFNHL2Cvt4hJ1dZZjUJFyNaCNl/">
                <div className="contact-detail">
                  <FaFacebookSquare className="contact-icon" />
                  <span>@Away-Homezone</span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
